// extracted by mini-css-extract-plugin
module.exports = {"resultsTable":"BatchSearchResults_resultsTable__2-Pqs","cell":"BatchSearchResults_cell__1-fkg","header":"BatchSearchResults_header__HKgQ5"};